import React from "react";
import { USER_INFO_OPTION } from "../../constants/updateVendorConstants";
import UpdateVendorProfile from "../../container/UpdateVendorProfiles/UpdateVendorProfiles";
import { PromptProvider } from "components/Modal/PromptProvider";
const UpdateUserInfo = () => (
  <PromptProvider>
    <UpdateVendorProfile bodyContent={USER_INFO_OPTION} />
  </PromptProvider>
);

export default UpdateUserInfo;